require('svg4everybody')();



// WEBPACK FOOTER //
// ./src/js/modules/polyfills.js